import CompLayout from "@/pcomponents/comp_stu/layout/layout";
import WordInsideUseListArea from "@/pages/comp_stu/plan/word_inside/common/use_list";

function WordInsideUseList() {

  return (
    <CompLayout>
      <WordInsideUseListArea></WordInsideUseListArea>
    </CompLayout>
  );
}

export default WordInsideUseList;